import styled from "styled-components";

export const _SvgLoading = styled.span`
  opacity: 0.4;
`;
